<template>
    <div class="navi">
        <router-link :to='getLinkTarget("HolterRequestAccept", "/philips/holter/HolterRequestAccept")'>
            <div :class='getClass("HolterRequestAccept")'><b-icon icon="stamper"/>受付</div>
        </router-link>
        <router-link :to='getLinkTarget("HolterDevicePreparation", "/philips/holter/HolterDevicePreparation")'>
            <div :class='getClass("HolterDevicePreparation")'><b-icon icon="barcode-scan"/>機器準備</div>
        </router-link>
        <router-link :to='getLinkTarget("HolterShippingList", "/philips/holter/HolterShippingList")'>
            <div :class='getClass("HolterShippingList")'><b-icon icon="truck-delivery-outline"/>機器出荷</div>
        </router-link>
        <router-link :to='getLinkTarget("HolterNumberOfShipmentSummary", "/philips/holter/HolterNumberOfShipmentSummary")'>
            <div :class='getClass("HolterNumberOfShipmentSummary")'><b-icon icon="file-excel"/>出荷実績シート</div>
        </router-link>
        <router-link :to='getLinkTarget("HolterDeviceReturn", "/philips/holter/HolterDeviceReturn")'>
            <div :class='getClass("HolterDeviceReturn")'><b-icon icon="receipt"/>機器受領</div>
        </router-link>
        <router-link :to='getLinkTarget("HolterAnalysisOrder", "/philips/holter/HolterAnalysisOrder")'>
            <div :class='getClass("HolterAnalysisOrder")'><b-icon icon="offer"/>解析依頼</div>
        </router-link>
        <router-link :to='getLinkTarget("HolterRequestContentChange", "/philips/holter/HolterRequestContentChange")'>
            <div :class='getClass("HolterRequestContentChange")'><b-icon icon="text-box-check"/>受付内容変更</div>
        </router-link>
    </div>
</template>

<script>
export default {
  name: "HolterNaviBar",
  props: ["pageid"],
  methods: {
      getLinkTarget: function(tabkind, target){
          var ret = target;
          if(tabkind == this.pageid){
              ret = ""
          }
          return ret;
      },
      getClass: function(tabkind) {
          var ret = "tabLabel ";
          if(tabkind == this.pageid){
            ret += "active";
          } else {
            ret += "deactive";
          }
          return ret;
      }

  },
  data() {
    return {
    };
  },
  filters: {},
  components: {},

};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 150px;
    height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterNaviBar.vue